import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Assemblies(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Assemblies</h2>
                <li>
                    <Link to={`${url}/belts`}>Belt and Chain Drives</Link>
                </li>
                <li>
                    <Link to={`${url}/pulleys`}>Pulleys</Link>
                </li>
                <li>
                    <Link to={`${url}/geartrains`}>Gear Trains</Link>
                </li>
                <li>
                    <Link to={`${url}/linearmotion`}>Linear Motion Systems</Link>
                </li>
                <li>
                    <Link to={`${url}/linkages`}>Linkages</Link>
                </li>
                <li>
                    <Link to={`${url}/clutches`}>Clutches and Brakes</Link>
                </li>
                <li>
                    <Link to={`${url}/cams`}>Cams</Link>
                </li>   
                <li>
                    <Link to={`${url}/leveling`}>Leveling</Link>
                </li>           
                <li>
                    <Link to={`${url}/heatex`}>Heat Exchangers</Link>
                </li>    
                <li>
                    <Link to={`${url}/robotarms`}>Robot Arms</Link>
                </li>       
                <li>
                    <Link to={`${url}/flexure`}>Flexure Mechanisms</Link>
                </li>      
                  <li>
                    <Link to={`${url}/drivedogs`}>Drive Dogs</Link>
                </li>   
                 <li>
                    <Link to={`${url}/planetary`}>Planetary Gearboxes</Link>
                </li>   
                   <li>
                    <Link to={`${url}/harmonic`}>Harmonic Drives</Link>
                </li>   
                   <li>
                    <Link to={`${url}/cycloidal`}>Cycloidal Drives</Link>
                </li>  
                <li>
                    <Link to={`${url}/ratchet`}>Ratchet & Pawl</Link>
                </li>  
                   <li>
                    <Link to={`${url}/multidirectionalwheels`}>Multidirectional Wheels</Link>
                </li>  
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Assemblies; 